import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_API_URL || '/api';

export const departmentApi = createApi({
  reducerPath: 'departmentApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Department'],
  endpoints: (builder) => ({
    // Get all departments
    getDepartments: builder.query({
      query: () => '/departments',
      providesTags: ['Department'],
    }),

    // Get department by ID
    getDepartment: builder.query({
      query: (id) => `/departments/${id}`,
      providesTags: (result, error, id) => [{ type: 'Department', id }],
    }),

    // Create department
    createDepartment: builder.mutation({
      query: (department) => ({
        url: '/departments',
        method: 'POST',
        body: department,
      }),
      invalidatesTags: ['Department'],
    }),

    // Update department
    updateDepartment: builder.mutation({
      query: ({ id, ...department }) => ({
        url: `/departments/${id}`,
        method: 'PUT',
        body: department,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Department', id },
        'Department',
      ],
    }),

    // Delete department
    deleteDepartment: builder.mutation({
      query: (id) => ({
        url: `/departments/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Department'],
    }),
  }),
});

export const {
  useGetDepartmentsQuery,
  useGetDepartmentQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
} = departmentApi;
